import {lazyComponent} from 'coreUtils/adapters/lazy';

const QuickSearchFlyout = lazyComponent(() => import('./QuickSearchFlyout'));

export {QuickSearchFlyout as default};
